var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "disruptions-table" }, [
    _c("div", { staticClass: "table-outer-container responsive-table-cards" }, [
      _c("div", { staticClass: "table-inner-container" }, [
        _c("table", [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._l(_vm.sortedEntries, function (disruption) {
                return _c(
                  "tr",
                  {
                    key: disruption.id,
                    class: _vm.isToday(disruption) ? "today" : "",
                  },
                  [
                    _c("td", { staticClass: "responsive-card-title" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "disruption-calendar-icon",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 448 512",
                          },
                        },
                        [
                          _c("path", {
                            staticClass: "fa-primary",
                            attrs: {
                              d: "M96 32C96 14.33 110.3 0 128 0C145.7 0 160 14.33 160 32V64H288V32C288 14.33 302.3 0 320 0C337.7 0 352 14.33 352 32V64H400C426.5 64 448 85.49 448 112V192H0V112C0 85.49 21.49 64 48 64H96V32zM256 432C256 449.7 241.7 464 224 464C206.3 464 192 449.7 192 432C192 414.3 206.3 400 224 400C241.7 400 256 414.3 256 432zM248 352C248 365.3 237.3 376 224 376C210.7 376 200 365.3 200 352V256C200 242.7 210.7 232 224 232C237.3 232 248 242.7 248 256V352z",
                            },
                          }),
                          _c("path", {
                            staticClass: "fa-secondary",
                            attrs: {
                              d: "M0 192H448V464C448 490.5 426.5 512 400 512H48C21.49 512 0 490.5 0 464V192zM224 400C206.3 400 192 414.3 192 432C192 449.7 206.3 464 224 464C241.7 464 256 449.7 256 432C256 414.3 241.7 400 224 400zM248 256C248 242.7 237.3 232 224 232C210.7 232 200 242.7 200 256V352C200 365.3 210.7 376 224 376C237.3 376 248 365.3 248 352V256z",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "encloser" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.localeStr(
                                disruption.attributes.startDateLocal
                              )
                            ) +
                            "\n                                "
                        ),
                        disruption.attributes.startDateLocal !==
                        disruption.attributes.endDateLocal
                          ? _c("span", [
                              _vm._v(
                                "– " +
                                  _vm._s(
                                    _vm.localeStr(
                                      disruption.attributes.endDateLocal
                                    )
                                  )
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "no-sm" }, [
                      _c(
                        "p",
                        { staticClass: "table-cell-title disruption-type" },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(disruption.attributes.type) +
                              "\n                            "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("div", [
                        _c("p", { staticClass: "table-cell-title" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(disruption.attributes.description) +
                              "\n                                "
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("div", [
                        disruption.attributes.toc
                          ? _c(
                              "p",
                              { staticClass: "toc-scope table-cell-title" },
                              [
                                _c("span", { staticClass: "sm-only" }, [
                                  _vm._v("Applies to "),
                                ]),
                                _vm._v(
                                  _vm._s(disruption.attributes.toc) +
                                    "\n                                "
                                ),
                              ]
                            )
                          : _c(
                              "p",
                              { staticClass: "toc-scope table-cell-title" },
                              [
                                _vm._v(
                                  "\n                                    All train operators\n                                "
                                ),
                              ]
                            ),
                      ]),
                    ]),
                  ]
                )
              }),
              _vm._v(" "),
              _vm.sortedEntries.length === 0
                ? _c("tr", { staticClass: "no-disruptions" }, [_vm._m(1)])
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Period")]),
        _vm._v(" "),
        _c("th", { staticClass: "no-sm" }, [
          _vm._v(
            "\n                            Type\n                        "
          ),
        ]),
        _vm._v(" "),
        _c("th", [_vm._v("Disruption")]),
        _vm._v(" "),
        _c("th", [_vm._v("TOCs Affected")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "3" } }, [
      _c("p", { staticClass: "table-cell-title" }, [
        _vm._v(
          "\n                                There are no upcoming disruptions to travel planned.\n                            "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }